// Theme: plasma
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'plasma',
  name: 'PLASMA',
  tagline: 'PLASMA',
  description: 'Plasma vivo com glow energizado e cards em glassmorphism.',
  category: 'neon-cyber',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#0F0B1A', '#1C1230', '#A855F7', '#F5E8FF'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.24)',
      '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)'
    },
    shellClasses: 'font-mono theme-plasma'
  },
  colorVars: {
    '--accent': '#A855F7',
    '--accent-foreground': '#0F0B1A',
    '--background': '#0F0B1A',
    '--border': '#4A1D7A',
    '--card': '#1C1230',
    '--card-border-active': 'rgba(168, 85, 247, 0.58)',
    '--card-completed': '#170F28',
    '--card-foreground': '#F5E8FF',
    '--card-glow': 'rgba(168, 85, 247, 0.12)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0F0B1A',
    '--foreground': '#F5E8FF',
    '--hold-fill': '#A855F7',
    '--input': '#4A1D7A',
    '--modal-bg': '#0F0B1A',
    '--modal-border': '#4A1D7A',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.24)',
    '--muted': '#4A1D7A',
    '--muted-foreground': '#F5E8FF',
    '--nav-active': '#A855F7',
    '--nav-bg': '#1C1230',
    '--popover': '#1C1230',
    '--popover-foreground': '#F5E8FF',
    '--primary': '#A855F7',
    '--primary-foreground': '#0F0B1A',
    '--ring': '#A855F7',
    '--secondary': '#4A1D7A',
    '--secondary-foreground': '#F5E8FF',
    '--streak': '#A855F7',
    '--success': '#22c55e',
    '--success-foreground': '#0F0B1A',
    '--xp': '#A855F7',
    '--xp-bg': '#1C1230'
  },
  resolvedVars: {
    '--accent': '#A855F7',
    '--accent-foreground': '#0F0B1A',
    '--accent-foreground-hsl': '256 41% 7%',
    '--accent-foreground-oklch': 'from #0F0B1A l c h',
    '--accent-hsl': '271 91% 65%',
    '--accent-oklch': 'from #A855F7 l c h',
    '--background': '#0F0B1A',
    '--background-hsl': '256 41% 7%',
    '--background-oklch': 'from #0F0B1A l c h',
    '--border': '#4A1D7A',
    '--border-hsl': '269 62% 30%',
    '--border-oklch': 'from #4A1D7A l c h',
    '--border-w': '1px',
    '--card': '#1C1230',
    '--card-border-active': 'rgba(168, 85, 247, 0.58)',
    '--card-completed': '#170F28',
    '--card-completed-hsl': '259 45% 11%',
    '--card-completed-oklch': 'from #170F28 l c h',
    '--card-foreground': '#F5E8FF',
    '--card-foreground-hsl': '274 100% 95%',
    '--card-foreground-oklch': 'from #F5E8FF l c h',
    '--card-glow': 'rgba(168, 85, 247, 0.12)',
    '--card-hsl': '260 45% 13%',
    '--card-oklch': 'from #1C1230 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0F0B1A',
    '--destructive-foreground-hsl': '256 41% 7%',
    '--destructive-foreground-oklch': 'from #0F0B1A l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#F5E8FF',
    '--foreground-hsl': '274 100% 95%',
    '--foreground-oklch': 'from #F5E8FF l c h',
    '--hold-fill': '#A855F7',
    '--hold-fill-hsl': '271 91% 65%',
    '--hold-fill-oklch': 'from #A855F7 l c h',
    '--input': '#4A1D7A',
    '--input-hsl': '269 62% 30%',
    '--input-oklch': 'from #4A1D7A l c h',
    '--modal-bg': '#0F0B1A',
    '--modal-bg-hsl': '256 41% 7%',
    '--modal-bg-oklch': 'from #0F0B1A l c h',
    '--modal-border': '#4A1D7A',
    '--modal-border-hsl': '269 62% 30%',
    '--modal-border-oklch': 'from #4A1D7A l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.24)',
    '--muted': '#4A1D7A',
    '--muted-foreground': '#F5E8FF',
    '--muted-foreground-hsl': '274 100% 95%',
    '--muted-foreground-oklch': 'from #F5E8FF l c h',
    '--muted-hsl': '269 62% 30%',
    '--muted-oklch': 'from #4A1D7A l c h',
    '--nav-active': '#A855F7',
    '--nav-active-hsl': '271 91% 65%',
    '--nav-active-oklch': 'from #A855F7 l c h',
    '--nav-bg': '#1C1230',
    '--nav-bg-hsl': '260 45% 13%',
    '--nav-bg-oklch': 'from #1C1230 l c h',
    '--popover': '#1C1230',
    '--popover-foreground': '#F5E8FF',
    '--popover-foreground-hsl': '274 100% 95%',
    '--popover-foreground-oklch': 'from #F5E8FF l c h',
    '--popover-hsl': '260 45% 13%',
    '--popover-oklch': 'from #1C1230 l c h',
    '--primary': '#A855F7',
    '--primary-foreground': '#0F0B1A',
    '--primary-foreground-hsl': '256 41% 7%',
    '--primary-foreground-oklch': 'from #0F0B1A l c h',
    '--primary-hsl': '271 91% 65%',
    '--primary-oklch': 'from #A855F7 l c h',
    '--radius': '12px',
    '--ring': '#A855F7',
    '--ring-hsl': '271 91% 65%',
    '--ring-oklch': 'from #A855F7 l c h',
    '--secondary': '#4A1D7A',
    '--secondary-foreground': '#F5E8FF',
    '--secondary-foreground-hsl': '274 100% 95%',
    '--secondary-foreground-oklch': 'from #F5E8FF l c h',
    '--secondary-hsl': '269 62% 30%',
    '--secondary-oklch': 'from #4A1D7A l c h',
    '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.24)',
    '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)',
    '--streak': '#A855F7',
    '--streak-hsl': '271 91% 65%',
    '--streak-oklch': 'from #A855F7 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#0F0B1A',
    '--success-foreground-hsl': '256 41% 7%',
    '--success-foreground-oklch': 'from #0F0B1A l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(271 91% 65% / 0.15)',
    '--xp': '#A855F7',
    '--xp-bg': '#1C1230',
    '--xp-bg-hsl': '260 45% 13%',
    '--xp-bg-oklch': 'from #1C1230 l c h',
    '--xp-hsl': '271 91% 65%',
    '--xp-oklch': 'from #A855F7 l c h'
  }
}
